import { checkoutAccommodationGroupingKey } from 'checkout/selectors/view/accommodation'
import { createSelector } from 'reselect'
import { getFlightItems } from '../view/flights'
import { getOccupantsFromItems } from 'lib/insurance/insuranceOccupants'
import { isAccommodationItem } from 'lib/checkout/checkoutUtils'
import { getInsuranceEnabledCheckoutItems } from '../view/insurance'

const getMultiItemOccupants = createSelector(
  (state: App.State) => getInsuranceEnabledCheckoutItems(state),
  (state: App.State) => getFlightItems(state),
  (items, flights) => {
    if (items.length === 0) return

    const accommodationItems = items.filter(item => isAccommodationItem(item))
    const accommodationOccupants = getOccupantsFromItems(
      accommodationItems,
      checkoutAccommodationGroupingKey,
      item => item.occupancy,
    )

    const flightOccupants = getOccupantsFromItems(
      flights,
      item => item.itemId,
      item => item.occupants,
    )

    return [...accommodationOccupants, ...flightOccupants]
  },
)

export default getMultiItemOccupants
